module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Widget */
(function(fox) {

	fox.registerWidget('Site_Page', {
		
		configure: function(options) {
			this.registerOptions('', {
				autoRender: true,
				active: false,
				description: '',
				keywords: '',
				dontReuseSnByHash: true
			});
			this._active = false;
			this._controlledParams = {};

			this.callParent('configure', arguments);
		},

		init: function() {
			if (this.getOption('naviParamsControl')) {
				this._readyToRender = false;
				this.handleEvent(fox.Navigator, 'modified', 'controlledNaviParamsHandler');
			}

			if (!this.getOption('template')) {
				this.setOption('template', this._widgetClass);
			}
			
			this.callParent('init', arguments);
			this._sitepage = this.alias;
		},

		activating: function() {
			fox.site.page = {
				widget: this,
				alias: this.alias,
				info: {}
			};
			return this.callParent('activating', arguments);
		},

		runPage: function() {
			this.getParent().switchEmbeddedWidget(this.alias);
		},

		setTitle: function() {
			var st = this._wom.getRoot().dl.getObjectValue('title') || 'MC',
				pt = this.getOption('title');
				pt = fox.isFunction(pt) ? pt.call(null) : pt;
			document.title = (pt ? pt + ' | ' : '') + st;
		},

		setPageOptions: function() {
			var st, pt, titlePage, titleOg, titleTwitter, description, descriptionOg, descriptionTwitter, keywords;
			
			if (!this.getOption('dynamicTitle') && !!fox.site.dl) {
				st = fox.site.dl.getObjectValue('title') || 'MC';
				pt = this.getOption('title');
				pt = fox.isFunction(pt) ? pt.call(null) : pt;
				titlePage = (pt ? pt + ' | ' : '') + st;
				
				document.title = titlePage;
				(titleOg = document.querySelector('meta[property="og:title"]')) &&
				titleOg.setAttribute('content', titlePage);
				(titleTwitter = document.querySelector('meta[name="twitter:title"]')) &&
				titleTwitter.setAttribute('content', titlePage);
			}

			desc = this.getOption('description');
			desc = fox.isFunction(desc) ? desc.call(null) : desc;
			(description = document.querySelector('meta[name="description"]')) &&
			description.setAttribute('content', desc);
			(descriptionOg = document.querySelector('meta[property="og:description"]')) &&
			descriptionOg.setAttribute('content', desc);
			(descriptionTwitter = document.querySelector('meta[name="twitter:description"]')) &&
			descriptionTwitter.setAttribute('content', desc);

			(keywords = document.querySelector('meta[name="keywords"]')) &&
			keywords.setAttribute('content',  this.getOption('keywords'));
		},

		activate: function() {
			var changed = this.controlledNaviParamsUpdated();
			this.callParent('activate', arguments);
			this.controlledNaviParamsChanged();

			fox.site.page = {alias: this.getAlias()};

			this.hookWrapper('setPageOptions');
			this.dispatchEvent('setPageOptions');
		},

		controlledNaviParamsChanged: function() {
			this.dispatchEvent('controlledNaviParamsChanged');
		},

		controlledNaviParamsHandler: function() {
			if (this.controlledNaviParamsUpdated()) {
				this.controlledNaviParamsChanged();
			}
		},

		controlledNaviParamsUpdated: function() {
			var changed = false;
			fox.each(this.getOption('naviParamsControl'), function(paramName) {
				var value = fox.Navigator.get(paramName);
				if (this._controlledParams[paramName] != value) {
					this._controlledParams[paramName] = value;
					changed = true;
				}
			}, this);
			return changed;
		}
	});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/site/page.js
// module id = 223
// module chunks = 0